import Vue from 'vue';
import VueI18n from 'vue-i18n';
import App from './App.vue';
import store from './store';
import router from './router';
import Amplify from 'aws-amplify';
import axios from 'axios';
import moment from 'moment';
import browserDetect from "vue-browser-detect-plugin";

Vue.prototype.$http = axios;
Vue.prototype.$moment = moment;

Amplify.configure({
    Auth: {
        // REQUIRED - Amazon Cognito Region
        region: 'eu-central-1',
        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: process.env.VUE_APP_COGNITO_USERPOOL_ID,
        // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
        userPoolWebClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,

        // OPTIONAL - Hosted UI configuration / federated signin configuration
        oauth: {
            domain: process.env.VUE_APP_COGNITO_APP_DOMAIN,
            scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
            redirectSignIn: process.env.VUE_APP_COGNITO_REDIRECT_URI,
            redirectSignOut: process.env.VUE_APP_COGNITO_REDIRECT_URI_SIGNOUT,
            responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
        }
    }
});

Vue.config.productionTip = true;

Vue.use(browserDetect);

Vue.use(VueI18n);
const locales = {
    en: require('./locales/en.json'),
    it: require('./locales/it.json')
};
const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: locales
});
Vue.filter('translate', function (value) {
    if (value) {
        return i18n.t(value);
    }
});

window.eventHub = new Vue();

new Vue({
    store,
    render: h => h(App),
    router,
    i18n
}).$mount('#app');